import { render, staticRenderFns } from "./Impressum.vue?vue&type=template&id=f442ae12&scoped=true"
var script = {}
import style0 from "./Impressum.vue?vue&type=style&index=0&id=f442ae12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f442ae12",
  null
  
)

export default component.exports